import React from 'react';
import { Route } from 'react-router-dom';
import { Authenticated } from 'react-admin';
import Invite from './containers/invite';
import SignUp from './containers/signup';
import ForgotPassword from './containers/forgot-password';
import PasswordReset from './containers/password-reset';

export default [
  <Route exact path="/forgot-password" component={ForgotPassword} noLayout />,
  <Route exact path="/password-reset/:token" component={PasswordReset} noLayout />,
  <Route exact path="/signup/:token" component={SignUp} noLayout />,
  <Route
    exact
    path="/invite"
    component={() => (
      <Authenticated>
        <Invite />
      </Authenticated>
    )}
  />,
];
